import { render, staticRenderFns } from "./monthly-storage-charge.vue?vue&type=template&id=59b9439c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./monthly-storage-charge.vue?vue&type=script&lang=js&"
export * from "./monthly-storage-charge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b9439c",
  null
  
)

export default component.exports